export default {"src":"/_next/static/media/beer.de0ea53b.svg","height":22,"width":19,"blurWidth":0,"blurHeight":0};